import { isSafari } from 'react-device-detect'
import { StyledProps } from 'styled-components'
import styled from 'styled-components/native'

import { SpacingTypes, ThemeColor } from 'utils/themes/types'

import { Box, BoxPadding } from '../Box'
import { ButtonSizeTypes } from '../Button'
import { Text } from '../Text'

type StyledIconButtonProps = StyledProps<{
  disabled?: boolean
  size?: ButtonSizeTypes
  type: ThemeColor
  hasTitle: boolean
  padding?: SpacingTypes | BoxPadding
  squared?: boolean
}>

export const StyledText = styled(Text)`
  padding-left: ${({ theme }) => theme.spacing.md}px;
`

export const StyledView = styled(Box)<StyledIconButtonProps>`
  display: flex;
  ${({ theme, type }) => (type ? `background-color: ${theme.colors[type]};` : null)}
  border-radius: ${({ theme }) => theme.borderRadius.xl}px;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  ${({ theme, disabled }) => (disabled ? `background-color: ${theme.colors.greyLight};` : null)}
  ${({ squared, theme, size }) =>
    squared && size
      ? `
  width: ${theme.buttons.sizes[size]}px;
  height: ${theme.buttons.sizes[size]}px;
  `
      : ''};
  ${isSafari ? 'letter-spacing: -0.7px' : ''}
`
